// Buat file baru untuk mengelola state registrasi

// Utility functions to manage registration state
export const saveRegistrationState = (data) => {
  const currentState = getRegistrationState() || {};
  const newState = { ...currentState, ...data };
  localStorage.setItem("registration_state", JSON.stringify(newState));
  return newState;
};

export const getRegistrationState = () => {
  const state = localStorage.getItem("registration_state");
  if (!state) return null;
  try {
    return JSON.parse(state);
  } catch (e) {
    return null;
  }
};

export const clearRegistrationState = () => {
  localStorage.removeItem("registration_state");
  // Also clear the old format storage keys
  localStorage.removeItem("register_form_data");
  localStorage.removeItem("register_details_form_data");
  localStorage.removeItem("register_preferences_data");
  localStorage.removeItem("register_form_data_details");
};

export const ensureRegistrationStateLoaded = async () => {
  return new Promise((resolve) => {
    // Kita butuh sedikit delay untuk memastikan localStorage telah dimuat
    setTimeout(() => {
      const data = getRegistrationState();
      resolve(data);
    }, 100);
  });
};
